export default __webpack_public_path__ + "static/media/Apa.a3043a69.svg";